// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 95 ? "f914b179" : chunkId) + "." + {"95":"1ea08e0dd31e2c17","166":"b5d2a6532e0ebccc"}[chunkId] + ".js";
};